import {Flex, Image, Loader, Text} from "@fluentui/react-northstar";
import CheckingListImage from "../../../../assets/check_list.svg";
import languageObject from "../../../../translations";
import React, {useEffect} from "react";
import {MailingListApi} from "../../../../apis/mailingListApi";

type Props = {
    file: ArrayBuffer | null,
    onFileChecked: (users: Array<string>) => void,
}

export const CheckingFile = (props: Props) => {

    useEffect(() => {
        MailingListApi.checkMailingListFile(props.file).then(res => {
            props.onFileChecked(res);
        });
    }, [props.file]);

    return (
        <Flex fill column hAlign={"center"} vAlign={"center"} gap={"gap.small"}>
            <Image fluid src={CheckingListImage} styles={{height: "250px", minHeight: "250px", objectFit: "contain"}}/>
            <Flex column hAlign={"center"} gap={"gap.medium"}>
                <Flex column hAlign={"center"} styles={{gap: "5px"}}>
                    <Text size={"large"} weight={"bold"} content={languageObject.translate("CheckingImportedUsers")}/>
                    <Text content={languageObject.translate("PleaseWaitAMoment")}/>
                </Flex>
                <Loader/>
            </Flex>
        </Flex>
    )
}